import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import emergencyDispatchListAction from './emergencyDispatchList.action.json' with { type: 'json' }
import { emergencyDispatchObject } from '../emergencyDispatchObject'

export const emergencyDispatchExpression = expression(emergencyDispatchObject.shape)

const emergencyDispatchListDefinition = defineAction({
  ...emergencyDispatchListAction,

  input: z.object({
    filter: emergencyDispatchExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      syncronizedAt: 'Data de sincronização',
      id: 'Identificador',
      code: 'Código',
      title: 'Título',
      status: 'Status',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(emergencyDispatchObject),
    count: z.number(),
  }),
})

export default emergencyDispatchListDefinition
